<script setup>
import { useCustomerChatUnread } from '@/composables/useCustomerChatUnread'

const { unreadCount } = useCustomerChatUnread()
const unreadLabel = computed(() => new Intl.NumberFormat('fa-IR').format(unreadCount.value))
const route = useRoute()
const isFavoritesPage = computed(() => route.path.startsWith("/client-page/favorites"))
const { isAuthenticated, openAuthDialog } = useAuthDialog()

const requireLogin = (event, target) => {
  if (isAuthenticated.value) return

  event.preventDefault()
  openAuthDialog(target)
}
</script>

<template>
  <VCard class="mt-3 px-6 py-3 mobile-menu">
    <div class="d-flex align-center justify-space-between">
      <NuxtLink to="/client-page" class="text-center items">
        <VIcon size="22" icon="tabler-brand-google-home" />
        <p class="mb-0">خانه</p>
      </NuxtLink>
      <NuxtLink to="/client-page/favorites" class="text-center items" @click="requireLogin($event, '/client-page/favorites')">
        <VIcon size="22" :icon="isFavoritesPage ? 'tabler-heart-filled' : 'tabler-heart'" />
        <p class="mb-0">علاقه‌مندی‌ها</p>
      </NuxtLink>
      <NuxtLink to="/my-booking" class="text-center items" @click="requireLogin($event, '/my-booking')">
        <VIcon size="22" icon="tabler-clubs" />
        <p class="mb-0">رزروهای من</p>
      </NuxtLink>
      <NuxtLink to="/client-page/messages" :aria-label="unreadCount ? `پیام‌ها، ${unreadLabel} پیام خوانده‌نشده` : 'پیام‌ها'" class="text-center items" @click="requireLogin($event, '/client-page/messages')">
        <span class="messages-icon">
          <VIcon size="22" icon="tabler-message-circle" />
          <span v-if="unreadCount > 0" class="messages-badge" aria-hidden="true">{{ unreadCount > 99 ? '۹۹+' : unreadLabel }}</span>
        </span>
        <p class="mb-0">پیام‌ها</p>
      </NuxtLink>
      <NuxtLink to="/user-profile" class="text-center items">
        <VIcon size="22" icon="custom-people-tag" />
        <p class="mb-0">حساب من</p>
      </NuxtLink>
    </div>
  </VCard>
</template>

<style lang="scss" scoped>
.messages-icon { position: relative; display: inline-flex; }
.messages-badge {
  position: absolute;
  top: -9px;
  inset-inline-end: -13px;
  min-width: 19px;
  height: 19px;
  padding: 0 4px;
  border: 2px solid rgb(var(--v-theme-surface));
  border-radius: 12px;
  background: #b42318;
  color: #fff;
  font-size: 10px;
  line-height: 15px;
  font-weight: 700;
  white-space: nowrap;
  direction: ltr;
}
.mobile-menu {
  position: fixed;
  right: 50%;
  bottom: 0;
  width: min(
    calc(100% - (2 * var(--client-app-gutter, 24px))),
    var(--client-app-max-width, 750px)
  );
  box-shadow: rgba(19, 20, 31, 0.12) 0px 1px 0px 0px inset;
  border-radius: 8px 8px 0 0;
  transform: translateX(50%);
  z-index: 999;
  .items {
    width: 80px;
    color: #13141f99;
    font-weight: 600;
    font-size: 12px;
    p {
      margin-top: 2px;
    }
    &.router-link-exact-active {
      color: rgb(var(--v-theme-primary));
      font-weight: bolder;
    }
  }
}

@media (max-width: 599px) {
  .mobile-menu {
    width: 100%;
  }
}
</style>
